import React, { memo } from 'react';
import { isMobile } from '@pascal/pascal-core';
import { TranslationKeys } from '../../../enums';

const AboutHashComp = ({ t, scrollRef }) => {
  return (
    <div className='pr-f-text-wrp' ref={scrollRef}>
      <p className='pr-f-text'>{isMobile() && t(TranslationKeys.ProvablyFairness)}</p>
      <p className='pr-f-text'>{t(TranslationKeys.FairnessP1)}</p>
      <p className='pr-f-text w-b-ba'>
        30F2D19BDC3B62C37E0C1A0C2DB5271AC7C5ABC1884BDF3A5A5CB2CF55A4F739DE7F8AFC81C346F75615A14020B98F9EAC3134EB385520926BC1BFB959AC7138
      </p>
      <p className='pr-f-text'>{t(TranslationKeys.FairnessP2)}</p>
      <p className='pr-f-text'>{t(TranslationKeys.FairnessP3)}</p>
      <p className='pr-f-text'>{t(TranslationKeys.FairnessP4)}</p>

      <ol className='pr-f-text'>
        <li className='pr-f-text'>1. {t(TranslationKeys.FairnessP5)}</li>
        <li className='pr-f-text'>2. {t(TranslationKeys.FairnessP6)}</li>
        <li className='pr-f-text'>3. {t(TranslationKeys.FairnessP7)}</li>
        <li className='pr-f-text'>4. {t(TranslationKeys.FairnessP8)}</li>
      </ol>

      <p className='pr-f-text'>{t(TranslationKeys.FairnessP9)}</p>
      <p className='pr-f-text'>{t(TranslationKeys.FairnessP10)}</p>
      <p className='pr-f-text'>{t(TranslationKeys.FairnessP11)}</p>
      <p className='pr-f-text w-b-ba'>
        30F2D19BDC3B62C37E0C1A0C2DB5271AC7C5ABC1884BDF3A5A5CB2CF55A4F739DE7F8AFC81C346F75615A14020B98F9EAC3134EB385520926BC1BFB959AC7138
      </p>
      <p className='pr-f-text'>{t(TranslationKeys.FairnessP12)}</p>
    </div>
  );
};
AboutHashComp.displayName = 'AboutHash';

export const AboutHash = memo(AboutHashComp);
